module.exports = __webpack_public_path__ + "media/images/favicon-61ec553678401782d6d78b0ab24cef77.ico";